module.exports = __webpack_public_path__ + "img/IMG_20240715_025421.fefeb616.jpg";